import { createRoute } from '@tanstack/react-router';

import { ManageOrganizations } from '../../features/organization/manage-organizations';
import { signInRoute } from '../signin';

export const manageOrganizationsRoute = createRoute({
  getParentRoute: () => signInRoute,
  path: '/organizations',
  component: ManageOrganizations,
});
